let _needsCountrySelection = false;

export function setCountryGateState(value) {
  _needsCountrySelection = !!value;
}

export function getCountryGateState() {
  return _needsCountrySelection;
}
